/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ApiDeliverySearchNFilterGridViewPostRequest } from "../models";
// @ts-ignore
import { ApiQuotationDRAFTPatchRequest } from "../models";
// @ts-ignore
import { ApiQuotationRequestContractPostRequest } from "../models";
// @ts-ignore
import { ContractRequestDropdowns } from "../models";
// @ts-ignore
import { DocumentFilterDimensions } from "../models";
// @ts-ignore
import { FileUriODataResultCollection } from "../models";
// @ts-ignore
import { OrderRequestDimension } from "../models";
// @ts-ignore
import { OrderRequestDropdowns } from "../models";
// @ts-ignore
import { QuotationModel } from "../models";
// @ts-ignore
import { QuotationModelODataResultCollection } from "../models";
/**
 * QuotationApi - axios parameter creator
 * @export
 */
export const QuotationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiQuotationDRAFTDocEntryGet", "docEntry", docEntry);
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiQuotationDRAFTDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Quotation/{DRAFT}/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTGet: async (
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiQuotationDRAFTGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Quotation/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTGetFormIdDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiQuotationDRAFTGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists(
        "apiQuotationDRAFTGetFormIdDocEntryGet",
        "dRAFT",
        dRAFT
      );
      const localVarPath = `/api/Quotation/{DRAFT}/GetFormId/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTPatch: async (
      dRAFT: string,
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiQuotationDRAFTPatch", "dRAFT", dRAFT);
      const localVarPath = `/api/Quotation/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiQuotationDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTUpdatePost: async (
      dRAFT: string,
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiQuotationDRAFTUpdatePost", "dRAFT", dRAFT);
      const localVarPath = `/api/Quotation/{DRAFT}/Update`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiQuotationDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiQuotationDocEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Quotation/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to provide valid dimensions of Quotation Line Items
     * @param {number} docEntry The Quotation DocEntry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDocEntryGetOrderRequestDimensionsGet: async (
      docEntry: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiQuotationDocEntryGetOrderRequestDimensionsGet",
        "docEntry",
        docEntry
      );
      const localVarPath =
        `/api/Quotation/{docEntry}/GetOrderRequestDimensions`.replace(
          `{${"docEntry"}}`,
          encodeURIComponent(String(docEntry))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to restrict options when creating orders
     * @param {number} docEntry the Quotation DocEntry
     * @param {string} [warehouseCode]
     * @param {string} [modeOfTransportationCode]
     * @param {string} [salesTermsCode]
     * @param {string} [shipToCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDocEntryGetOrderRequestDropdownsGet: async (
      docEntry: number,
      warehouseCode?: string,
      modeOfTransportationCode?: string,
      salesTermsCode?: string,
      shipToCode?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiQuotationDocEntryGetOrderRequestDropdownsGet",
        "docEntry",
        docEntry
      );
      const localVarPath =
        `/api/Quotation/{docEntry}/GetOrderRequestDropdowns`.replace(
          `{${"docEntry"}}`,
          encodeURIComponent(String(docEntry))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (warehouseCode !== undefined) {
        localVarQueryParameter["warehouseCode"] = warehouseCode;
      }

      if (modeOfTransportationCode !== undefined) {
        localVarQueryParameter["modeOfTransportationCode"] =
          modeOfTransportationCode;
      }

      if (salesTermsCode !== undefined) {
        localVarQueryParameter["salesTermsCode"] = salesTermsCode;
      }

      if (shipToCode !== undefined) {
        localVarQueryParameter["shipToCode"] = shipToCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGet: async (
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} cardCode
     * @param {string} itemCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetContractRequestDropdownsGet: async (
      cardCode: string,
      itemCode: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'cardCode' is not null or undefined
      assertParamExists(
        "apiQuotationGetContractRequestDropdownsGet",
        "cardCode",
        cardCode
      );
      // verify required parameter 'itemCode' is not null or undefined
      assertParamExists(
        "apiQuotationGetContractRequestDropdownsGet",
        "itemCode",
        itemCode
      );
      const localVarPath = `/api/Quotation/GetContractRequestDropdowns`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (cardCode !== undefined) {
        localVarQueryParameter["cardCode"] = cardCode;
      }

      if (itemCode !== undefined) {
        localVarQueryParameter["itemCode"] = itemCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to provide valid dimensions of Quotation GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetDocumentFilterDimensionsGet: async (
      $filter?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation/GetDocumentFilterDimensions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetFileUriListDocEntryGet: async (
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiQuotationGetFileUriListDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/Quotation/GetFileUriList/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetFormIdDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiQuotationGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/Quotation/GetFormId/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationPatch: async (
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiQuotationDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to created contract and return docEntry
     * @param {ApiQuotationRequestContractPostRequest} [apiQuotationRequestContractPostRequest] The contractRequestModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationRequestContractPost: async (
      apiQuotationRequestContractPostRequest?: ApiQuotationRequestContractPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation/RequestContract`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiQuotationRequestContractPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used by Search box on Contract List View
     * @param {string} [searchString] The search string.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationSearchGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation/Search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [searchString] The search string.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationSearchGridViewGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation/SearchGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationSearchNFilterGridViewPost: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation/SearchNFilterGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliverySearchNFilterGridViewPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationUpdatePost: async (
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Quotation/Update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiQuotationDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("docEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Quotation({DocEntry})`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QuotationApi - functional programming interface
 * @export
 */
export const QuotationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    QuotationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDRAFTDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDRAFTDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDRAFTGet(
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuotationModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDRAFTGet(
          dRAFT,
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDRAFTGetFormIdDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDRAFTGetFormIdDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDRAFTPatch(
      dRAFT: string,
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDRAFTPatch(
          dRAFT,
          apiQuotationDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDRAFTUpdatePost(
      dRAFT: string,
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDRAFTUpdatePost(
          dRAFT,
          apiQuotationDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDocEntryGet(
          docEntry,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used to provide valid dimensions of Quotation Line Items
     * @param {number} docEntry The Quotation DocEntry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDocEntryGetOrderRequestDimensionsGet(
      docEntry: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<OrderRequestDimension>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDocEntryGetOrderRequestDimensionsGet(
          docEntry,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used to restrict options when creating orders
     * @param {number} docEntry the Quotation DocEntry
     * @param {string} [warehouseCode]
     * @param {string} [modeOfTransportationCode]
     * @param {string} [salesTermsCode]
     * @param {string} [shipToCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationDocEntryGetOrderRequestDropdownsGet(
      docEntry: number,
      warehouseCode?: string,
      modeOfTransportationCode?: string,
      salesTermsCode?: string,
      shipToCode?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<OrderRequestDropdowns>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationDocEntryGetOrderRequestDropdownsGet(
          docEntry,
          warehouseCode,
          modeOfTransportationCode,
          salesTermsCode,
          shipToCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationGet(
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuotationModelODataResultCollection>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuotationGet(
        isDraft,
        $top,
        $skip,
        $filter,
        $orderby,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} cardCode
     * @param {string} itemCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationGetContractRequestDropdownsGet(
      cardCode: string,
      itemCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractRequestDropdowns>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationGetContractRequestDropdownsGet(
          cardCode,
          itemCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used to provide valid dimensions of Quotation GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationGetDocumentFilterDimensionsGet(
      $filter?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DocumentFilterDimensions>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationGetDocumentFilterDimensionsGet(
          $filter,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationGetFileUriListDocEntryGet(
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FileUriODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationGetFileUriListDocEntryGet(
          docEntry,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationGetFormIdDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationGetFormIdDocEntryGet(
          docEntry,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationPatch(
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationPatch(
          apiQuotationDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used to created contract and return docEntry
     * @param {ApiQuotationRequestContractPostRequest} [apiQuotationRequestContractPostRequest] The contractRequestModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationRequestContractPost(
      apiQuotationRequestContractPostRequest?: ApiQuotationRequestContractPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationRequestContractPost(
          apiQuotationRequestContractPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used by Search box on Contract List View
     * @param {string} [searchString] The search string.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationSearchGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuotationModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationSearchGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [searchString] The search string.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationSearchGridViewGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuotationModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationSearchGridViewGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationSearchNFilterGridViewPost(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuotationModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationSearchNFilterGridViewPost(
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          apiDeliverySearchNFilterGridViewPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiQuotationDRAFTPatchRequest} [apiQuotationDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiQuotationUpdatePost(
      apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiQuotationUpdatePost(
          apiQuotationDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async docEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuotationModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.docEntryGet(
        docEntry,
        isDraft,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * QuotationApi - factory interface
 * @export
 */
export const QuotationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = QuotationApiFp(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {QuotationApiApiQuotationDRAFTDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTDocEntryGet(
      requestParameters: QuotationApiApiQuotationDRAFTDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModel> {
      return localVarFp
        .apiQuotationDRAFTDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {QuotationApiApiQuotationDRAFTGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTGet(
      requestParameters: QuotationApiApiQuotationDRAFTGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModelODataResultCollection> {
      return localVarFp
        .apiQuotationDRAFTGet(
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QuotationApiApiQuotationDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTGetFormIdDocEntryGet(
      requestParameters: QuotationApiApiQuotationDRAFTGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiQuotationDRAFTGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {QuotationApiApiQuotationDRAFTPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTPatch(
      requestParameters: QuotationApiApiQuotationDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModel> {
      return localVarFp
        .apiQuotationDRAFTPatch(
          requestParameters.dRAFT,
          requestParameters.apiQuotationDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {QuotationApiApiQuotationDRAFTUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDRAFTUpdatePost(
      requestParameters: QuotationApiApiQuotationDRAFTUpdatePostRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModel> {
      return localVarFp
        .apiQuotationDRAFTUpdatePost(
          requestParameters.dRAFT,
          requestParameters.apiQuotationDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {QuotationApiApiQuotationDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDocEntryGet(
      requestParameters: QuotationApiApiQuotationDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModel> {
      return localVarFp
        .apiQuotationDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used to provide valid dimensions of Quotation Line Items
     * @param {QuotationApiApiQuotationDocEntryGetOrderRequestDimensionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDocEntryGetOrderRequestDimensionsGet(
      requestParameters: QuotationApiApiQuotationDocEntryGetOrderRequestDimensionsGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<OrderRequestDimension>> {
      return localVarFp
        .apiQuotationDocEntryGetOrderRequestDimensionsGet(
          requestParameters.docEntry,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used to restrict options when creating orders
     * @param {QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationDocEntryGetOrderRequestDropdownsGet(
      requestParameters: QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<OrderRequestDropdowns> {
      return localVarFp
        .apiQuotationDocEntryGetOrderRequestDropdownsGet(
          requestParameters.docEntry,
          requestParameters.warehouseCode,
          requestParameters.modeOfTransportationCode,
          requestParameters.salesTermsCode,
          requestParameters.shipToCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {QuotationApiApiQuotationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGet(
      requestParameters: QuotationApiApiQuotationGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModelODataResultCollection> {
      return localVarFp
        .apiQuotationGet(
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QuotationApiApiQuotationGetContractRequestDropdownsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetContractRequestDropdownsGet(
      requestParameters: QuotationApiApiQuotationGetContractRequestDropdownsGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<ContractRequestDropdowns> {
      return localVarFp
        .apiQuotationGetContractRequestDropdownsGet(
          requestParameters.cardCode,
          requestParameters.itemCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used to provide valid dimensions of Quotation GridView
     * @param {QuotationApiApiQuotationGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetDocumentFilterDimensionsGet(
      requestParameters: QuotationApiApiQuotationGetDocumentFilterDimensionsGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DocumentFilterDimensions> {
      return localVarFp
        .apiQuotationGetDocumentFilterDimensionsGet(
          requestParameters.$filter,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QuotationApiApiQuotationGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetFileUriListDocEntryGet(
      requestParameters: QuotationApiApiQuotationGetFileUriListDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FileUriODataResultCollection> {
      return localVarFp
        .apiQuotationGetFileUriListDocEntryGet(
          requestParameters.docEntry,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QuotationApiApiQuotationGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationGetFormIdDocEntryGet(
      requestParameters: QuotationApiApiQuotationGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiQuotationGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {QuotationApiApiQuotationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationPatch(
      requestParameters: QuotationApiApiQuotationPatchRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModel> {
      return localVarFp
        .apiQuotationPatch(
          requestParameters.apiQuotationDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used to created contract and return docEntry
     * @param {QuotationApiApiQuotationRequestContractPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationRequestContractPost(
      requestParameters: QuotationApiApiQuotationRequestContractPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiQuotationRequestContractPost(
          requestParameters.apiQuotationRequestContractPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used by Search box on Contract List View
     * @param {QuotationApiApiQuotationSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationSearchGet(
      requestParameters: QuotationApiApiQuotationSearchGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModelODataResultCollection> {
      return localVarFp
        .apiQuotationSearchGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {QuotationApiApiQuotationSearchGridViewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationSearchGridViewGet(
      requestParameters: QuotationApiApiQuotationSearchGridViewGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModelODataResultCollection> {
      return localVarFp
        .apiQuotationSearchGridViewGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {QuotationApiApiQuotationSearchNFilterGridViewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationSearchNFilterGridViewPost(
      requestParameters: QuotationApiApiQuotationSearchNFilterGridViewPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModelODataResultCollection> {
      return localVarFp
        .apiQuotationSearchNFilterGridViewPost(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {QuotationApiApiQuotationUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuotationUpdatePost(
      requestParameters: QuotationApiApiQuotationUpdatePostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModel> {
      return localVarFp
        .apiQuotationUpdatePost(
          requestParameters.apiQuotationDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {QuotationApiDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet(
      requestParameters: QuotationApiDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<QuotationModel> {
      return localVarFp
        .docEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiQuotationDRAFTDocEntryGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDRAFTDocEntryGetRequest
 */
export interface QuotationApiApiQuotationDRAFTDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof QuotationApiApiQuotationDRAFTDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof QuotationApiApiQuotationDRAFTDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiQuotationDRAFTGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDRAFTGetRequest
 */
export interface QuotationApiApiQuotationDRAFTGetRequest {
  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof QuotationApiApiQuotationDRAFTGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiQuotationDRAFTGetFormIdDocEntryGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDRAFTGetFormIdDocEntryGetRequest
 */
export interface QuotationApiApiQuotationDRAFTGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof QuotationApiApiQuotationDRAFTGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTGetFormIdDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof QuotationApiApiQuotationDRAFTGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiQuotationDRAFTPatch operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDRAFTPatchRequest
 */
export interface QuotationApiApiQuotationDRAFTPatchRequest {
  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTPatch
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiQuotationDRAFTPatchRequest}
   * @memberof QuotationApiApiQuotationDRAFTPatch
   */
  readonly apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest;
}

/**
 * Request parameters for apiQuotationDRAFTUpdatePost operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDRAFTUpdatePostRequest
 */
export interface QuotationApiApiQuotationDRAFTUpdatePostRequest {
  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDRAFTUpdatePost
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiQuotationDRAFTPatchRequest}
   * @memberof QuotationApiApiQuotationDRAFTUpdatePost
   */
  readonly apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest;
}

/**
 * Request parameters for apiQuotationDocEntryGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDocEntryGetRequest
 */
export interface QuotationApiApiQuotationDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof QuotationApiApiQuotationDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof QuotationApiApiQuotationDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiApiQuotationDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiQuotationDocEntryGetOrderRequestDimensionsGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDocEntryGetOrderRequestDimensionsGetRequest
 */
export interface QuotationApiApiQuotationDocEntryGetOrderRequestDimensionsGetRequest {
  /**
   * The Quotation DocEntry.
   * @type {number}
   * @memberof QuotationApiApiQuotationDocEntryGetOrderRequestDimensionsGet
   */
  readonly docEntry: number;
}

/**
 * Request parameters for apiQuotationDocEntryGetOrderRequestDropdownsGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGetRequest
 */
export interface QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGetRequest {
  /**
   * the Quotation DocEntry
   * @type {number}
   * @memberof QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGet
   */
  readonly warehouseCode?: string;

  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGet
   */
  readonly modeOfTransportationCode?: string;

  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGet
   */
  readonly salesTermsCode?: string;

  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGet
   */
  readonly shipToCode?: string;
}

/**
 * Request parameters for apiQuotationGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationGetRequest
 */
export interface QuotationApiApiQuotationGetRequest {
  /**
   *
   * @type {boolean}
   * @memberof QuotationApiApiQuotationGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationApiApiQuotationGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationApiApiQuotationGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationApiApiQuotationGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationApiApiQuotationGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiApiQuotationGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiQuotationGetContractRequestDropdownsGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationGetContractRequestDropdownsGetRequest
 */
export interface QuotationApiApiQuotationGetContractRequestDropdownsGetRequest {
  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationGetContractRequestDropdownsGet
   */
  readonly cardCode: string;

  /**
   *
   * @type {string}
   * @memberof QuotationApiApiQuotationGetContractRequestDropdownsGet
   */
  readonly itemCode: string;
}

/**
 * Request parameters for apiQuotationGetDocumentFilterDimensionsGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationGetDocumentFilterDimensionsGetRequest
 */
export interface QuotationApiApiQuotationGetDocumentFilterDimensionsGetRequest {
  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationApiApiQuotationGetDocumentFilterDimensionsGet
   */
  readonly $filter?: string;
}

/**
 * Request parameters for apiQuotationGetFileUriListDocEntryGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationGetFileUriListDocEntryGetRequest
 */
export interface QuotationApiApiQuotationGetFileUriListDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof QuotationApiApiQuotationGetFileUriListDocEntryGet
   */
  readonly docEntry: number;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationApiApiQuotationGetFileUriListDocEntryGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationApiApiQuotationGetFileUriListDocEntryGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationApiApiQuotationGetFileUriListDocEntryGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationApiApiQuotationGetFileUriListDocEntryGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiQuotationGetFormIdDocEntryGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationGetFormIdDocEntryGetRequest
 */
export interface QuotationApiApiQuotationGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof QuotationApiApiQuotationGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof QuotationApiApiQuotationGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiQuotationPatch operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationPatchRequest
 */
export interface QuotationApiApiQuotationPatchRequest {
  /**
   *
   * @type {ApiQuotationDRAFTPatchRequest}
   * @memberof QuotationApiApiQuotationPatch
   */
  readonly apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest;
}

/**
 * Request parameters for apiQuotationRequestContractPost operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationRequestContractPostRequest
 */
export interface QuotationApiApiQuotationRequestContractPostRequest {
  /**
   * The contractRequestModel
   * @type {ApiQuotationRequestContractPostRequest}
   * @memberof QuotationApiApiQuotationRequestContractPost
   */
  readonly apiQuotationRequestContractPostRequest?: ApiQuotationRequestContractPostRequest;
}

/**
 * Request parameters for apiQuotationSearchGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationSearchGetRequest
 */
export interface QuotationApiApiQuotationSearchGetRequest {
  /**
   * The search string.
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiQuotationSearchGridViewGet operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationSearchGridViewGetRequest
 */
export interface QuotationApiApiQuotationSearchGridViewGetRequest {
  /**
   * The search string.
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGridViewGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGridViewGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGridViewGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGridViewGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGridViewGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchGridViewGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiQuotationSearchNFilterGridViewPost operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationSearchNFilterGridViewPostRequest
 */
export interface QuotationApiApiQuotationSearchNFilterGridViewPostRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchNFilterGridViewPost
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchNFilterGridViewPost
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchNFilterGridViewPost
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchNFilterGridViewPost
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiApiQuotationSearchNFilterGridViewPost
   */
  readonly $expand?: string;

  /**
   * The filter and search string requirement.
   * @type {ApiDeliverySearchNFilterGridViewPostRequest}
   * @memberof QuotationApiApiQuotationSearchNFilterGridViewPost
   */
  readonly apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest;
}

/**
 * Request parameters for apiQuotationUpdatePost operation in QuotationApi.
 * @export
 * @interface QuotationApiApiQuotationUpdatePostRequest
 */
export interface QuotationApiApiQuotationUpdatePostRequest {
  /**
   *
   * @type {ApiQuotationDRAFTPatchRequest}
   * @memberof QuotationApiApiQuotationUpdatePost
   */
  readonly apiQuotationDRAFTPatchRequest?: ApiQuotationDRAFTPatchRequest;
}

/**
 * Request parameters for docEntryGet operation in QuotationApi.
 * @export
 * @interface QuotationApiDocEntryGetRequest
 */
export interface QuotationApiDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof QuotationApiDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof QuotationApiDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof QuotationApiDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * QuotationApi - object-oriented interface
 * @export
 * @class QuotationApi
 * @extends {BaseAPI}
 */
export class QuotationApi extends BaseAPI {
  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {QuotationApiApiQuotationDRAFTDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDRAFTDocEntryGet(
    requestParameters: QuotationApiApiQuotationDRAFTDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDRAFTDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {QuotationApiApiQuotationDRAFTGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDRAFTGet(
    requestParameters: QuotationApiApiQuotationDRAFTGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDRAFTGet(
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QuotationApiApiQuotationDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDRAFTGetFormIdDocEntryGet(
    requestParameters: QuotationApiApiQuotationDRAFTGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDRAFTGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {QuotationApiApiQuotationDRAFTPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDRAFTPatch(
    requestParameters: QuotationApiApiQuotationDRAFTPatchRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDRAFTPatch(
        requestParameters.dRAFT,
        requestParameters.apiQuotationDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {QuotationApiApiQuotationDRAFTUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDRAFTUpdatePost(
    requestParameters: QuotationApiApiQuotationDRAFTUpdatePostRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDRAFTUpdatePost(
        requestParameters.dRAFT,
        requestParameters.apiQuotationDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {QuotationApiApiQuotationDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDocEntryGet(
    requestParameters: QuotationApiApiQuotationDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used to provide valid dimensions of Quotation Line Items
   * @param {QuotationApiApiQuotationDocEntryGetOrderRequestDimensionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDocEntryGetOrderRequestDimensionsGet(
    requestParameters: QuotationApiApiQuotationDocEntryGetOrderRequestDimensionsGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDocEntryGetOrderRequestDimensionsGet(
        requestParameters.docEntry,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used to restrict options when creating orders
   * @param {QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationDocEntryGetOrderRequestDropdownsGet(
    requestParameters: QuotationApiApiQuotationDocEntryGetOrderRequestDropdownsGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationDocEntryGetOrderRequestDropdownsGet(
        requestParameters.docEntry,
        requestParameters.warehouseCode,
        requestParameters.modeOfTransportationCode,
        requestParameters.salesTermsCode,
        requestParameters.shipToCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {QuotationApiApiQuotationGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationGet(
    requestParameters: QuotationApiApiQuotationGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationGet(
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QuotationApiApiQuotationGetContractRequestDropdownsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationGetContractRequestDropdownsGet(
    requestParameters: QuotationApiApiQuotationGetContractRequestDropdownsGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationGetContractRequestDropdownsGet(
        requestParameters.cardCode,
        requestParameters.itemCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used to provide valid dimensions of Quotation GridView
   * @param {QuotationApiApiQuotationGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationGetDocumentFilterDimensionsGet(
    requestParameters: QuotationApiApiQuotationGetDocumentFilterDimensionsGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationGetDocumentFilterDimensionsGet(
        requestParameters.$filter,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QuotationApiApiQuotationGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationGetFileUriListDocEntryGet(
    requestParameters: QuotationApiApiQuotationGetFileUriListDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationGetFileUriListDocEntryGet(
        requestParameters.docEntry,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QuotationApiApiQuotationGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationGetFormIdDocEntryGet(
    requestParameters: QuotationApiApiQuotationGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {QuotationApiApiQuotationPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationPatch(
    requestParameters: QuotationApiApiQuotationPatchRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationPatch(
        requestParameters.apiQuotationDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used to created contract and return docEntry
   * @param {QuotationApiApiQuotationRequestContractPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationRequestContractPost(
    requestParameters: QuotationApiApiQuotationRequestContractPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationRequestContractPost(
        requestParameters.apiQuotationRequestContractPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used by Search box on Contract List View
   * @param {QuotationApiApiQuotationSearchGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationSearchGet(
    requestParameters: QuotationApiApiQuotationSearchGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationSearchGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Searches the grid view.
   * @param {QuotationApiApiQuotationSearchGridViewGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationSearchGridViewGet(
    requestParameters: QuotationApiApiQuotationSearchGridViewGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationSearchGridViewGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Searches the grid view.
   * @param {QuotationApiApiQuotationSearchNFilterGridViewPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationSearchNFilterGridViewPost(
    requestParameters: QuotationApiApiQuotationSearchNFilterGridViewPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationSearchNFilterGridViewPost(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {QuotationApiApiQuotationUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public apiQuotationUpdatePost(
    requestParameters: QuotationApiApiQuotationUpdatePostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .apiQuotationUpdatePost(
        requestParameters.apiQuotationDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {QuotationApiDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotationApi
   */
  public docEntryGet(
    requestParameters: QuotationApiDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return QuotationApiFp(this.configuration)
      .docEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
